import React, { FC, useState } from "react";
import { Button, Input, message, Modal, Table } from "antd";
import { YhBox } from "@/components/YhBox";
import { ColumnsType } from "antd/es/table";
import { RouterParamType } from "@/model/navModel";
import { usePurchasesDetailModel } from "../purchasesDetailModel";
import { formatInt, formatNum } from '@/utils/utils';
import { EditableCell, EditableRow } from '@/components/YHEditTable/editTable';
import { IPurchasesMaterial } from '@/views/purchases/purchasesTypes';
import { DictCodeEnmu } from "@/types/AppDictEnums";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/AppResourceAuthEnum";
import { enquiryService } from "@/views/inquires/enquiry/enquiryService";

export const TableBox: FC<RouterParamType> = ({ id, mode }) => {
    const {
        addList,
        editList, addDesc, editDesc,
        editFormVal,
        addFormVal,
        updateList,
        removeMaterial,
        setMaterialDialog
    } = usePurchasesDetailModel(({ addList, editList, addDesc, editDesc, }) => [addList, editList, addDesc, editDesc,]);
    const tableList = mode === "edit" ? editList : addList;
    const desc = mode === "edit" ? editDesc : addDesc;
    const formVal = mode === "edit" ? editFormVal : addFormVal;
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);

    const columns = [
        {
            title: '序号',
            width: 45,
            align: "center",
            fixed: "left",
            dataIndex: "totalTxt",
            render: (t: any, r: any, i: number) => <>{t ? t : i + 1}</>
        }, {
            title: '商品编码',
            width: 160,
            dataIndex: 'materialCode',
        }, {
            title: '商品名称',
            width: 160,
            dataIndex: 'materialName',
        }, {
            title: '商品名称-英文',
            width: 160,
            dataIndex: 'materialEname',
        }, {
            title: '商品类型',
            width: 160,
            dataIndex: 'typeName',
        }, {
            title: '规格型号',
            width: 160,
            dataIndex: 'model',
        }, {
            title: '单位',
            width: 120,
            dataIndex: 'unitName',
        }, {
            title: '*采购数量',
            width: 160,
            dataIndex: 'num',
            editable: true
        }, {
            title: '海关编码',
            width: 100,
            dataIndex: 'customsCode',
        }, {
            title: '采购单价',
            width: 160,
            dataIndex: 'price',
            render: (text: any) => text === "null" ? "" : `￥${formatNum(text)}`,
            editable: true
        }, {
            title: '采购金额',
            width: 160,
            dataIndex: 'amount',
            render: (text: any) => `￥${formatNum(text)}`,
            editable: true
        },
        // {
        //     title: '仓库',
        //     width: 160,
        //     dataIndex: 'warehouseName',
        // }, {
        //     title: '货位',
        //     width: 160,
        //     dataIndex: 'shelfCode',
        // }
    ];
    const newColumn = columns.map((col: any, index) => {
        return {
            ...col,
            onCell: (record: any, rowIndex: number) => ({
                colIndex: index + 1,
                rowIndex,
                record,
                rules: col.rules,
                options: col.options,
                editType: col.editType,
                //最后一行合计不可以编辑, 已结算的不可以修改
                editable: (record.key === "totalAmount" || formVal.status === DictCodeEnmu.PURCHASE_SETTLE) ? false : col?.editable,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave: handleSave,
            }),
        }
    });

    //内联编辑
    const handleSave = (row: any) => {
        let dataSource = [...tableList];
        const index = dataSource.findIndex((item) => row.key === item.key);
        const item = dataSource[index];

        row.num = +formatInt(row.num);
        row.price = +formatNum(row.price);
        //修改总价， 不走计算
        if (+row.amount === +(item.amount ?? 0)) {
            row.amount = formatNum(row.num * row.price);
        } else {
            row.amount = formatNum(row.amount);
        }

        dataSource.splice(index, 1, { ...item, ...row });
        updateList(mode, dataSource);
    }
    const action = <>
        <YhAuth resCode={ResourceAuthEnum.P_ED_AD}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                disabled={formVal.status === DictCodeEnmu.PURCHASE_SETTLE}
                onClick={() => {
                    setMaterialDialog(true)
                }}
            >新增</Button>
        </YhAuth>
        {/* <YhAuth resCode={ResourceAuthEnum.P_ED_DEL_M}> */}
        <Button
            className="mr-5"
            type="link"
            shape="round"
            disabled={(mode === "edit" && formVal.status !== DictCodeEnmu.PURCHASE_INIF)}
            onClick={() => {
                if (!selectedRowKeys.length) {
                    message.warning("请选择你要删除的商品");
                    return;
                }
                removeMaterial(mode, selectedRowKeys)
                setSelectedRowKeys([])
            }}
        >删除</Button>
        {/* </YhAuth> */}
        {/* <YhAuth resCode={ResourceAuthEnum.P_ED_DLOAD}> */}
        {/* <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => { }}
        >导入</Button> */}
        {/* </YhAuth> */}
        {/* <YhAuth resCode={ResourceAuthEnum.P_ED_EX}> */}
        {/* <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => { }}
        >导出</Button> */}
        {/* </YhAuth> */}

    </>

    const leftChildren = mode === 'edit' ? <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => {
                if (selectedRowKeys.length !== 1) {
                    message.warning("请选择单条数据进行排序");
                    return;
                }
                let number = "";
                Modal.confirm({
                    title: "请输入排序数字",
                    content: <>
                        <Input placeholder="请输入排序数字" onChange={(e) => { number = e.target.value }} />
                    </>,
                    okText: '确定',
                    cancelText: '取消',
                    onOk: () => {
                        return new Promise((resolve, reject) => {
                            if (number && /^[+-]?\d*\.?\d*$/.test(number)) {
                                resolve(number);
                            } else {
                                message.warning("请输入排序数字");
                                reject('请输入排序数字');
                            }
                        }).then(async (res: any) => {
                            let { retData } = await enquiryService.purchaseOrderNum({
                                id: selectedRowKeys[0],
                                orderNum: +res
                            })
                            message.success("修改成功")
                        });
                    },
                    onCancel: () => { }
                })
            }}
        >修改顺位</Button>
    </> : <></>

    const totalRow: IPurchasesMaterial = {
        key: "totalAmount",
        totalTxt: "合计:",
        num: desc.numAll,
        amount: formatNum(desc.amountAll),
        price: "null",
    }

    return (
        <YhBox title={leftChildren} style={{ marginBottom: "75px" }} rightChildren={action}>
            <Table
                rowClassName='editable-row yh-edit-table-tr'
                rowSelection={{
                    selectedRowKeys: selectedRowKeys, //记录选中
                    getCheckboxProps: (record) => {
                        let checkboxProps: any = {};
                        if (record.key === "totalAmount") {
                            checkboxProps.disabled = true;
                        }
                        return checkboxProps;
                    },
                    onChange: (selectedRowKeys: React.Key[], selectedRows: IPurchasesMaterial[]) => {
                        setSelectedRowKeys(selectedRowKeys as string[]);
                        // setSelectedRowKeys(selectedRowKeys.filter(item => item !== "totalAmount") as string[]);
                    }
                }}
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    },
                }}
                columns={newColumn as ColumnsType<any>}
                dataSource={tableList.length > 0 ? [...tableList, totalRow] : []}
                pagination={false}
                scroll={{ x: 'max-content', y: 400 }}
            />
        </YhBox>
    )
}
